import '@shared/infra/translation'
import '@shared/infra/adapters/amplify'
import './styles/global.css'
import './lib/sentry'

import { setDefaultOptions } from 'date-fns'
import { enUS, es, ptBR } from 'date-fns/locale'
import { NuqsAdapter } from 'nuqs/adapters/react'
import ReactDOM from 'react-dom/client'

import { version as PkgVersion } from '../package.json'
import App from './App'
import { enableMSW } from './api/_mocks'
import { applicationLocale } from './components/navbar/currency-lang-toggle'

const locale =
  applicationLocale === 'es-ES'
    ? es
    : applicationLocale === 'en-US'
      ? enUS
      : ptBR

setDefaultOptions({
  locale,
})

localStorage.setItem('version', PkgVersion)

enableMSW().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  )

  return root.render(
    <NuqsAdapter>
      <App />
    </NuqsAdapter>,
  )
})
